import {Component} from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-master-data',
    templateUrl: './master-data.component.html',
})
export class MasterDataComponent
{
}
